module.exports = __webpack_public_path__ + "assets/img/18_1811.16cba056.jpg";